import React, { PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import { SafeAreaView } from 'react-native-safe-area-context';

import { theme, useResponsive } from '@sg/garnish';

export const FlexLandingPageContainer = (props: PropsWithChildren) => {
  const { match } = useResponsive();

  return (
    <ScrollView contentContainerStyle={styles.scrollView}>
      <SafeAreaView style={match([styles.containerXS, styles.containerSM])} edges={['top']}>
        {props.children}
      </SafeAreaView>
    </ScrollView>
  );
};

const FlexLandingPageContainerContent = (props: PropsWithChildren) => {
  const { match } = useResponsive();

  return <View style={match([styles.contentXS, styles.contentSM])}>{props.children}</View>;
};

FlexLandingPageContainer.Content = FlexLandingPageContainerContent;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  scrollView: {
    flexGrow: 1,
  },
  containerXS: {
    flexGrow: 1,
  },
  containerSM: {
    flexGrow: 1,
    paddingTop: theme.spacing['10'],
  },
  contentXS: {
    gap: theme.spacing['6'],
  },
  contentSM: {
    gap: theme.spacing['10'],
  },
});
